import * as d3 from "d3";
import {
  IAveragePositionData,
  IEventsPositionData,
} from "../types/IDefensiveHullData";

export const renderDefensiveHull = (
  svg: d3.Selection<SVGSVGElement, unknown, any, undefined>,
  xScale: d3.ScaleLinear<number, number>,
  yScale: d3.ScaleLinear<number, number>,
  data: {
    eventsPositions: IEventsPositionData[];
    innerEventsPositions: IEventsPositionData[];
    averagePosition: IAveragePositionData;
    playerName: string;
  },
  color: "red" | "blue"
) => {
  if (
    data.averagePosition !== null &&
    data.averagePosition.location_X > 0 &&
    data.averagePosition.location_Y > 0
  ) {
    const x = xScale(data.averagePosition.location_X);
    const y = yScale(data.averagePosition.location_Y - 2);
    svg
      .append("circle")
      .attr("cx", x)
      .attr("cy", y)
      .attr("r", 6)
      .style("fill", color);
    svg
      .append("text")
      .text(data.playerName)
      .attr("x", x + 10)
      .attr("y", y + 5)
      .style("fill", color);
    data.eventsPositions.forEach((d) => {
      svg
        .append("circle")
        .attr("cx", xScale(d.location_X))
        .attr("cy", yScale(d.location_Y))
        .attr("r", 2)
        .style("fill", color);
    });
    if (data.eventsPositions?.length >= 3) {
      const hullPoints = d3.polygonHull(
        data.eventsPositions.map((d) => [
          xScale(d.location_X),
          yScale(d.location_Y),
        ])
      );

      const lineGenerator = d3
        .line<[number, number]>()
        .x((d) => d[0])
        .y((d) => d[1])
        .curve(d3.curveLinearClosed);

      svg
        .append("path")
        .datum(hullPoints)
        .attr("d", lineGenerator as any)
        .style("fill", color)
        .style("fill-opacity", 0.2)
        .style("stroke", color)
        .style("stroke-width", 1);
      if (data.innerEventsPositions?.length >= 3) {
        const innerHullPoints = d3.polygonHull(
          data.innerEventsPositions.map((d) => [
            xScale(d.location_X),
            yScale(d.location_Y),
          ])
        );
        svg
          .append("path")
          .datum(innerHullPoints)
          .attr("d", lineGenerator as any)
          .style("fill", color)
          .style("fill-opacity", 0.2)
          .style("stroke", color)
          .style("stroke-width", 1);
      }
    }
  }
};
